module.exports = __webpack_public_path__ + "img/footer-icon-row-light-lincoln.524d20b3.png";